// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTelegramPlane,
  FaWhatsapp
} from 'react-icons/fa';

import threadsIcon from '../assets/threads-icon.png';

const Footer = () => {
  return (
    <>
      <footer className="footer text-center py-4">
        {/* Social Media Icons */}
        <div className="social-icons mb-3">
          <a
            href="https://facebook.com/kashmirjobsfb"
            className="facebook"
            target="_blank"
            rel="noreferrer"
            title="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://instagram.com/kashmir_jobs"
            className="instagram"
            target="_blank"
            rel="noreferrer"
            title="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://linkedin.com/in/kashmir-jobs"
            className="linkedin"
            target="_blank"
            rel="noreferrer"
            title="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://t.me/kashmir_jobs"
            className="telegram"
            target="_blank"
            rel="noreferrer"
            title="Telegram"
          >
            <FaTelegramPlane />
          </a>
          <a
            href="https://wa.me/918494056223"
            className="whatsapp"
            target="_blank"
            rel="noreferrer"
            title="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://www.threads.net/@kashmir_jobs"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon threads"
            title="Follow on Threads"
          >
            <img
              src={threadsIcon}
              alt="Threads"
              style={{ width: '20px', height: '20px', filter: 'invert(1)' }}
            />
          </a>
        </div>

        {/* Quick Links */}
        <div className="quick-links mb-2">
          <Link to="/">Home</Link> |{' '}
          <Link to="/jobs">Jobs</Link> |{' '}
          <Link to="/post-job">Post a Job</Link> |{' '}
          <Link to="/about">About Us</Link> |{' '}
          <Link to="/contact">Contact Us</Link> |{' '}
          <Link to="/disclaimer">Disclaimer</Link> |{' '}
          <Link to="/vision" className="footer-link"> Our Vision</Link>
        </div>

        {/* Copyright */}
        <div className="text-muted small">
          © {new Date().getFullYear()} Kashmir Jobs. All rights reserved.
        </div>
      </footer>

      {/* 🔵 Gradient Strip Below Footer */}
      <div className="footer-gradient-strip" />
    </>
  );
};

export default Footer;
